// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class Tier {
  readonly name: string;
  readonly type: string;
  readonly externalID: string | null;
  readonly integrationID: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.name = data.name === undefined ? '' : data.name;
    this.type = data.type === undefined ? '' : data.type;
    this.externalID = data.externalID === undefined ? null : data.externalID;
    this.integrationID = data.integrationID === undefined ? null : data.integrationID;
  }

  static zero(): Tier {
    const zeroValues: ExcludeMethodsDeep<Tier> = {
      name: '',
      type: '',
      externalID: null,
      integrationID: null,
    };
    return new Tier(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type TierWireFormat = {
  name: string;
  type: string;
  externalID: string | null;
  integrationID: string | null;
};

type NewTierProps = PartialDeep<Tier, { recurseIntoArrays: true }>;
export const NewTier: (props: NewTierProps) => Tier = (props) => new Tier(props);

type NewTierFromWireFormatProps = PartialDeep<TierWireFormat, { recurseIntoArrays: true }>;
export const NewTierFromWireFormat: (props: NewTierFromWireFormatProps) => Tier = (props) =>
  new Tier(props);
